import React, { useEffect, useState } from "react";
import { ScrollPanel } from "primereact/scrollpanel";
import axios from "axios";
import formatDate from "../formatDate";

export default function FicheLogTerminal({ idFicheDem }) {
  const [logData, setLogData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  function isValidDate(value) {
    const date = new Date(value);
    return !isNaN(date.getTime()) && /^\d{4}-\d{2}-\d{2}/.test(value);
  }

  useEffect(() => {
    if (!idFicheDem) return;

    axios
      .get(`${apiUrl}/IHM/api/ficheDem.php?journalFiche=${idFicheDem}`)
      .then((res) => {
        setLogData(res.data);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération du log :", err);
      });
  }, [idFicheDem]);


  const champLabels = {
    note: "Note :",
    dateVisite: "Devis :",
    dateDevis: "Suivis :",
    dateValidation: "Devis validé :",
    dateDem: "Déménagement :",
    dateRappel: "Rappel :",
    etat: "Abandonnée",

    mailAvis: "Mail demande d'avis :",
    mailSuivis: "Mail relance de devis :",
    mailContact: "Mail de contact :",
    mailDem: "Mail de déménagement :",
    sms: "sms de déménagement"
  };

  const allLogs = [...logData]
    .filter((entry) => entry.dateAction)
    .sort((a, b) => new Date(b.dateAction) - new Date(a.dateAction));

  const formatDateLocal = (datetimeStr) => {
    const d = new Date(datetimeStr);
    return `${d.toLocaleDateString()}`;
  };

  return (
    <>
      <div className="grid">
        <div className="col-12 md:col-12 font-bold">
          <div className="py-0 border-round-sm surface-100 flex flex-column">
            Historiques des notes :
          </div>
        </div>
      </div>

      <div className="grid">
        {" "}
        <div className="col-12 md:col-12">
          {allLogs.map((entry, index) => (
            <div
              key={index}
              style={{
                padding: "10px",
                fontSize: "0.75rem",
                border: "1px solid #f3f4f6",
                background: "#f3f4f6",
                borderRadius: "5px",
                marginBottom: "2px",
              }}
            >
              <span>
                [{formatDateLocal(entry.dateAction)}]{" "}
                {entry.actionType?.toUpperCase() === "INSERT"
                  ? "Insertion"
                  : 
  
                    (entry.nouvelleValeur === "6" && entry.champModifie === "etat")
                    ?'ZotDevis'
                    : champLabels[entry.champModifie] || entry.champModifie
    
                }
              </span>{" "}
              {entry.actionType?.toUpperCase() === "UPDATE" &&
              entry.nouvelleValeur &&
              entry.nouvelleValeur !== "0000-00-00" &&
              entry.nouvelleValeur.toLowerCase() !== "null" ? (
                <>
                  {(entry.nouvelleValeur !== "5" && entry.nouvelleValeur !== "6" && entry.nouvelleValeur !== "1") && (
                    <span>
                      {isValidDate(entry.nouvelleValeur)
                        ? formatDateLocal(entry.nouvelleValeur)
                        : entry.nouvelleValeur}
                    </span>
                  )}{" "}
                  
                  [{entry.adminNote}]{" "}

                  {(entry.champModifie !== 'note') && (
                     entry.message && <>Note : {entry.message}</>
                  )

                  }
                 
                </>
              ) : entry.actionType?.toUpperCase() === "UPDATE" ? (
                <>
                  <span style={{ color: "#999" }}>Non renseignée</span> - [
                  {entry.adminNote}]{" "}
                  {entry.message && <>Note : {entry.message}</>}
                </>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
